import { render, staticRenderFns } from "./StatutoryContent.vue?vue&type=template&id=2d73e1da&scoped=true&"
import script from "./StatutoryContent.vue?vue&type=script&lang=js&"
export * from "./StatutoryContent.vue?vue&type=script&lang=js&"
import style0 from "./StatutoryContent.vue?vue&type=style&index=0&id=2d73e1da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d73e1da",
  null
  
)

export default component.exports